import React from 'react'
import bowser from 'bowser'
// @ts-ignore
import preloaderUrl from 'player/assets/preloader.mp4'
import './Preloader.scss'

// Checking bowser.name is empty for mobile
const Preloader = () => bowser.mobile || !bowser.name
  ? (
    <div styleName="preloader-container">
      <div styleName="css-preloader" />
    </div>
  )
  : (
    <div styleName="preloader" data-id="preloader" data-testid="preloader">
      <video src={preloaderUrl} autoPlay muted loop>
        <source src={preloaderUrl} type="video/mp4" />
      </video>
    </div>
  )
export default Preloader
